<template>
  <div class="homePage">
    <div class="sidebar">
      <div class="help">
        <router-link to="/help">
          帮助
        </router-link>
      </div>
      <div class="logo">
        <img src="../../assets/client/head.png" alt="">
      </div>
      <div class="btnBox">
        <br><br>
        <div class="head">
          <div class="title">房间号</div>
          <div class="btn" v-on:click="handQueryChild()" >查询</div>
        </div>
        <div class="content">
          <input type="text"
                 :value="this.roomObj.roomId"
                 placeholder="请输入房间ID"
                 @keyup="saveRoomId"
                 @keyup.enter="handQueryChild()"
          >
        </div>
        <br><br>
      </div>
      <div class="nav">
        <div :class="{item:true,active:$route.path ==='/'}">
          <RouterLink to="/">弹幕设置</RouterLink>
        </div>
      </div>
      <div class="btnBox">
        <div class="head">
          <div class="title">房间URL</div>
          <div class="btn" v-on:click="copyRoomUrl('roomUrl')" >复制
          </div>
        </div>
        <div class="content">
          <input type="text" :value="roomUrl" readonly>
        </div>
      </div>
      <div class="btnBox" v-if="this.elementHidden === 'false'">
        <div class="head">
          <div class="title">测试URL</div>
          <div class="btn" v-on:click="copyRoomUrl('roomTestUrl')" >复制
          </div>
        </div>
        <div class="content">
          <input type="text" :value="roomTestUrl" readonly>
        </div>
      </div>

      <div class="nav">
        <div :class="{item:true,active:$route.path ==='/giftSetting'}">
          <RouterLink to="/giftSetting">送礼播报</RouterLink>
        </div>
      </div>
      <div class="btnBox">
        <div class="head">
          <div class="title">房间URL</div>
          <div class="btn" v-on:click="copyRoomUrl('giftRoomUrl')" >复制
          </div>
        </div>
        <div class="content">
          <input type="text" :value="giftRoomUrl" readonly>
        </div>
      </div>
      <div class="btnBox" v-if="this.elementHidden === 'false'">
        <div class="head">
          <div class="title">测试URL</div>
          <div class="btn"  v-on:click="copyRoomUrl('giftRoomTestUrl')" >复制
          </div>
        </div>
        <div class="content">
          <input type="text" :value="giftRoomTestUrl" readonly>
        </div>
      </div>
      <div style="height: 25px; position: absolute; bottom: 0;" ><a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2023043165号</a></div>

      <!-- 跳转到新系统提示框 -->
      <dialog-component v-if="Visiable" ref="dialog"></dialog-component>

    </div>
    <div class="content">
      <div class="container">
        <RouterView ref="child"></RouterView>
      </div>
    </div>
  </div>
</template>

<script>
import { objectToQuery } from "@/utils"
import { CLIENT_CONFIG, GIFT_CONFIG } from "@/api/chatConfig"
import dialogComponent from "@/components/DialogComponent"

export default {
  name: "ClientHome",
  //  2.在components中注册dialogComponent组件
  components:{
    dialogComponent
  },
  data() {
    return {
      elementHidden: process.env.VUE_APP_ELEMENT_HIDDEN,
      config: {
        ...CLIENT_CONFIG,
        roomKeyType: 2
      },
      giftConfig: {
        ...GIFT_CONFIG,
        roomKeyType: 2
      },
      identityCode: this.$route.query.Code,
      roomObj: {
        roomId: localStorage.getItem('roomId') == "null" ? "" : localStorage.getItem('roomId')
      },
      Visiable: true,
    }
  },
  provide() {
    return {
      config: this.config,
      giftConfig: this.giftConfig,
      roomObj: this.roomObj,
    }
  },
  computed: {
    roomUrl: vm => {
      return `${window.origin}/client/room/${vm.roomObj.roomId}?${objectToQuery(vm.config)}`
    },
    roomTestUrl: vm => {
      return `${window.origin}/client/room/test?${objectToQuery(vm.config)}`
    },
    giftRoomUrl: vm => {
      return `${window.origin}/client/giftRoom/${vm.roomObj.roomId}?${objectToQuery(vm.giftConfig)}`
    },
    giftRoomTestUrl: vm => {
      return `${window.origin}/client/giftRoom/test?${objectToQuery(vm.giftConfig)}`
    },
  },
  methods: {
    saveRoomId(event) {
      this.roomObj.roomId = event.target.value
      localStorage.setItem('roomId', this.roomObj.roomId)
    },
    copyRoomUrl(content) {
      // console.log(this.elementHidden)
      switch(content){
        case "roomUrl":
          if (this.roomObj.roomId && this.config.skin) {
            this.$copyText(this.roomUrl)
            this.$message({
              message: '<span style="font-size: 25px; padding-right: 15px;">复制成功</span>',
              type: 'success',
              dangerouslyUseHTMLString: true,
              offset: 300
            })
          } else {
            let tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败</span>'
            if (!this.roomObj.roomId && !this.config.skin) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输入房间号并选择皮肤！</span>'
            }else if (!this.roomObj.roomId) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输入房间号！</span>'
            } else if (!this.config.skin) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输选择皮肤！</span>'
            }
            this.$copyText('')
            this.$message({
              message: tipMsg,
              type: 'error',
              dangerouslyUseHTMLString: true,
              offset: 300
            })
          }
          break
        case "roomTestUrl":
          if (this.config.skin) {
            this.$copyText(this.roomTestUrl)
            this.$message({
              message: '<span style="font-size: 25px; padding-right: 15px;">复制成功</span>',
              type: 'success',
              dangerouslyUseHTMLString: true,
              offset: 300
            })
          } else {
            let tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败</span>'
            if (!this.roomObj.roomId && !this.config.skin) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输入房间号并选择皮肤！</span>'
            }else if (!this.roomObj.roomId) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输入房间号！</span>'
            } else if (!this.config.skin) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输选择皮肤！</span>'
            }
            this.$copyText('')
            this.$message({
              message: tipMsg,
              type: 'error',
              dangerouslyUseHTMLString: true,
              offset: 300
            })
          }
          break
        case "giftRoomUrl":
          if (this.roomObj.roomId && this.giftConfig.skin) {
            this.$copyText(this.giftRoomUrl)
            this.$message({
              message: '<span style="font-size: 25px; padding-right: 15px;">复制成功</span>',
              type: 'success',
              dangerouslyUseHTMLString: true,
              offset: 300
            })
          } else {
            let tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败</span>'
            if (!this.roomObj.roomId && !this.giftConfig.skin) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输入房间号并选择皮肤！</span>'
            }else if (!this.roomObj.roomId) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输入房间号！</span>'
            } else if (!this.giftConfig.skin) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输选择皮肤！</span>'
            }
            this.$copyText('')
            this.$message({
              message: tipMsg,
              type: 'error',
              dangerouslyUseHTMLString: true,
              offset: 300
            })
          }
          break
        case "giftRoomTestUrl":
          if (this.giftConfig.skin) {
            this.$copyText(this.giftRoomTestUrl)
            this.$message({
              message: '<span style="font-size: 25px; padding-right: 15px;">复制成功</span>',
              type: 'success',
              dangerouslyUseHTMLString: true,
              offset: 300
            })
          } else {
            let tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败</span>'
            if (!this.roomObj.roomId && !this.giftConfig.skin) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输入房间号并选择皮肤！</span>'
            }else if (!this.roomObj.roomId) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输入房间号！</span>'
            } else if (!this.giftConfig.skin) {
              tipMsg = '<span style="font-size: 25px; padding-right: 15px;">复制失败，请输选择皮肤！</span>'
            }
            this.$copyText('')
            this.$message({
              message: tipMsg,
              type: 'error',
              dangerouslyUseHTMLString: true,
              offset: 300
            })
          }
          break
        default:
          this.$copyText('')
          break
      }
    },
    handQueryChild() {
      // console.log("handQueryChild()")
      this.$refs.child.getList()
    },
  },
  mounted: function(){
    // console.log('Component mounted.')
    this.Visiable = true;
    this.$nextTick(()=>{
      //这里的dialog与上面dialog-component组件里面的ref属性值是一致的
      //init调用的是dialog-component组件里面的init方法
      //data是传递给弹窗页面的值
      this.$refs.dialog.init('弹窗组件执行了');
    })
  }
}
</script>

<style scoped lang="less">
.homePage {
  width: 100%;
  height: 100%;
  display: flex;
  font-size: var(--fontSize);
  //font-family: SourceHanSansCN-Bold,serif;

  * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  a:active, a:hover, a:link {
    background: none;
  }

  input {
    display: block;
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
  }

  .f1 {
    flex: 1;
  }

  .sidebar {
    width: 286px;
    height: 100%;
    background: var(--sidebarBgColor);
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;

    .help {
      position: absolute;
      top: 7px;
      right: 9px;
      width: 54px;
      height: 24px;
      background: #fff;
      border-radius: 24px;
      text-align: center;
      line-height: 24px;
      font-size: 16px;

      a {
        color: var(--btnFontColor);
      }
    }

    .logo {
      img {
        width: 186px;
      }
    }

    .info {
      margin-top: 20px;

      img {
        width: 133px;
      }
    }

    .nav {
      margin-bottom: 20px;

      .item {
        margin-top: 20px;
        width: 207px;
        height: 51px;

        border-radius: 10px;
        text-align: center;
        line-height: 51px;
        font-size: 28px;
        font-weight: bold;
        background: #fff;

        a {
          color: #8b9eb7;
        }

        &.active {
          background: #869bb7;

          a {
            color: #fff;
          }
        }
      }
    }

    .btnBox {
      width: 266px;
      margin-bottom: 20px;

      .head {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 5px;

        .title {
          color: var(--fontColor);
        }

        .btn {
          color: var(--btnFontColor);
          background: var(--btnBgColor);
          padding: 3px 20px;
          border-radius: 25px;
          cursor: pointer;
        }
      }

      .content {
        background: #fff;
        width: 100%;
        height: 33px;
        line-height: 33px;
        border: 2px solid var(--borderColor);
        padding: 0 5px;

        input {
          font-size: 14px;
        }
      }
    }
  }

  .content {
    flex: 1;
    background: #edf5ff;
    padding: 20px;
    display: flex;
    flex-direction: column;
    height: 100%;

    .nav {
      display: flex;
      margin-bottom: 20px;
      gap: 15px;

      .item {
        width: 110px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--btnBgColorDark);
        color: var(--btnFontColorDark);
        border-radius: 36px;

        &.active {
          background: var(--btnBgColor);
          color: var(--btnBgColorDark);
          border: 2px solid var(--btnBgColorDark);
        }
      }
    }

    .container {
      flex: 1;
      background: #fff;
      box-shadow: 0 0 15px 5px rgba(0, 0, 0, .2);
      border-radius: 10px;
      overflow-x: hidden;
      overflow-y: auto;
    }
  }
}
</style>
